<template>
  <a-modal
  :visible="visible.resProduct"
  width="900px"
  title="请选择需要生成产品的可行配方"
  :bodyStyle="{padding:'10px'}"
  @cancel="toggleVisible('resProduct')"
  @ok="save"
>
<a-spin :spinning="resLoading" tip="产品更新中">
  <a-table
    :columns="columns"
    bordered
    :scroll="{ x:0, y: 450 }"
    :loading="rawListLoading"
    :data-source="list.records"
    :row-selection="{selectedRowKeys, onChange: onSelectChange}"
    :row-key="record => record.id"
    :pagination="false"
  >
  <span slot="uasge" slot-scope="text">{{text == null ? text : text.toFixed(3)}}</span>
</a-table>
</a-spin>
</a-modal>
</template>

<script>
import { formulaMixins } from '../unitls'
export default {
mixins:[formulaMixins],
data(){
  return {
    rawListLoading:false,
    resLoading:false,
    columns:[
      {
        dataIndex:'formulaCode',
        title:'配方代码'
      },
      {
        dataIndex:'formulaName',
        title:'配方名称'
      },
      {
        dataIndex:'animalTypeName',
        title:'动物类型'
      },
      {
        dataIndex:'factoryName',
        title:'工厂名称'
      }
    ]
  }
},
watch:{
  'visible.resProduct'(val){
    if(val){ 
      this.getList()
    } else {
      this.cleanSelect()
    }
  }
},
methods:{
  getList(arg = {}) {
    this.fetchGet({
      actions: this.selectFormulaTaskFormulaHaveSolutionPage,
      name: 'list',
      loading: "rawListLoading",
      data: {
        current: 1,
        taskId: this.$route.query.id,
        size: 1000,
        ...arg
      }
    });
  },
  async save(){
    if(this.selectedRows.length > 0){
      await this.fetchPost({
        actions:this.createFormulaProductByIds,
        loading:'resLoading',
        data:{
          ids:this.selectedRows.map(i=>i.id).join()
        }
      })
      this.toggleVisible('resProduct')
      this.setState({
        resRaw:this.resRaw + 1,
        resNut:this.resNut + 1,
      })
    } else {
      this.$message.warn('请选择要更新的配方')
    }
  }
},
}
</script>

<style>

</style>